
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';

import { useSearchProjectId } from '../../project';

import { getDefinition } from '../reducers';
import { getActions } from '../sagas';

export default function useSearchDefinition() {
    const dispatch = useDispatch();
    const searchActions = getActions(dispatch);

    const searchDefinition = useSelector(state => getDefinition(state.search));
    const searchProjectId = useSearchProjectId();

    React.useEffect(() => {
        if (searchProjectId && !searchDefinition.searchDefinition && !searchDefinition.loading) {
            searchActions.getDefinition(searchProjectId);
        }
        return () => {
            // nop;
        };
    }, [searchProjectId]);


    return searchDefinition;
}
